import styled from 'styled-components';

export const Step3Content = styled.div`
  > p:first-child {
    font-family: inherit;
    margin-top: 10px;
    color: #656a66;
    margin-bottom: 24px;
  }
  input {
    margin-top: 0;
  }
`;
